import axios from 'axios'

export default {
    async BankInformation(IBAN){
        const response = await axios.get(`/api/bankoperations/get/bankinformation/${IBAN}`)
        return response
    },
    async List(IBAN){
        const response = await axios.get(`/api/bankoperations/select/list/banks`)
        return response
    },
    CompanyBankAccount:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/bankoperations/companyaccount/update' : '/api/bankoperations/companyaccount/create',data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/bankoperations/companyaccount/delete/${id}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/bankoperations/companyaccount/table',data)
            return response
        },
        async List(bool = true){
            const response = await axios.get(`/api/bankoperations/companyaccount/list/${bool}`)
            return response
        }
    }
}